import React from 'react'
import Button from '@material-ui/core/Button'

import { useProjectsFiltersStyles } from './projects-filters.styles'
import { useProjectsFilters } from '../use-projects-filters'
import { useTranslation } from '@plandi/common'

export const ProjectsFiltersSidebarClear: React.FC = () => {
  const classes = useProjectsFiltersStyles()
  const { data: translate } = useTranslation()

  const { clearProjectFilters } = useProjectsFilters()

  return (
    <div className={classes.rowNew}>
      <Button
        variant="text"
        onClick={clearProjectFilters}
        className={classes.buttonFilters}
      >
        {translate?.shop['models-page']['filters']}
      </Button>
    </div>
  )
}
